// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-products-buy-one-click-agreement-bdhpg{color:var(--color-gray);font-size:12px;margin-bottom:16px}.components-products-buy-one-click-button-bujpj{justify-content:center}.components-products-buy-one-click-button-bujpj.components-products-buy-one-click-mobile-bjqfr{width:100%}.components-products-buy-one-click-button-bujpj.components-products-buy-one-click-desktop-bmyod{width:240px}.components-products-buy-one-click-thanks-qhkcj{text-align:center}.components-products-buy-one-click-thanksTitle-brudf{font-size:20px;font-weight:700;margin-bottom:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"agreement": "components-products-buy-one-click-agreement-bdhpg",
	"button": "components-products-buy-one-click-button-bujpj",
	"mobile": "components-products-buy-one-click-mobile-bjqfr",
	"desktop": "components-products-buy-one-click-desktop-bmyod",
	"thanks": "components-products-buy-one-click-thanks-qhkcj",
	"thanksTitle": "components-products-buy-one-click-thanksTitle-brudf"
};
module.exports = ___CSS_LOADER_EXPORT___;
